import { lazy, Suspense } from 'react';

import { ModalWrapper } from '@braskai/ui-kit';

import { useScreenRecordPromoModalStore } from '@/features/screenRecordPromo';

const ScreenRecordPromoModalContent = lazy(() =>
  import('./ScreenRecordPromoModalContent').then((module) => ({
    default: module.ScreenRecordPromoModalContent,
  })),
);

export const ScreenRecordPromoModal = () => (
  <ModalWrapper hook={useScreenRecordPromoModalStore}>
    <Suspense fallback={null}>
      <ScreenRecordPromoModalContent />
    </Suspense>
  </ModalWrapper>
);
